import React from "react";
import { Text, View } from "@react-pdf/renderer";
import styles from "./style";

const EmptyInvoiceCell = ({ width }) => (
  <View style={{ ...styles.qty, ...styles.borderRightTop, width }}>
    <Text>-</Text>
  </View>
);

const ComplementaryServiceRow = ({ complementaryServiceText }) => {
  return (
    <View style={styles.mainDataRow}>
      <View
        style={{
          ...styles.desc,
          ...styles.borderRightTop,
          width: "40%",
        }}
      >
        <Text style={styles.complementaryServiceLabel}>
          Complimentary Service
        </Text>
        <Text style={styles.complementaryServiceValue}>
          {complementaryServiceText}
        </Text>
      </View>
      <EmptyInvoiceCell width="15%" />
      <EmptyInvoiceCell width="15%" />
      <EmptyInvoiceCell width="15%" />
      <EmptyInvoiceCell width="15%" />
      <View
        style={{
          ...styles.amount,
          ...styles.borderRightTop,
          width: "20%",
        }}
      >
        <Text>-</Text>
      </View>
    </View>
  );
};

export default ComplementaryServiceRow;
